var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 8.85L13 27.58V63h51V27.55L38 8.85zM60 59H42V48h-8v11H17V29.58l21-15.77L60 29.6V59zm-8-19h-8v-8h8v8zm-28-8h8v8h-8v-8z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/CZ_Home.6119c280.svg";
export { SvgCzHome as ReactComponent };